<template>
  <div>
    <BaseLayoutSpaced>
      <ValidationProvider
        name="from"
        vid="actionProps.from"
        rules="required"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup>
          <BaseFormLabel :for="`${_uid}-from`"> From * </BaseFormLabel>

          <BaseFormInput v-model="data.from" :id="`${_uid}-from`" class="block" />

          <p v-if="failed" class="msg error mt-2 text-xs">
            {{ errors[0] }}
          </p>
        </BaseFormGroup>
      </ValidationProvider>

      <ValidationProvider
        name="message"
        vid="actionProps.message"
        rules="required"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup>
          <BaseFormLabel :for="`${_uid}-message`"> Message * </BaseFormLabel>

          <BaseFormInlineMessage info>
            {{ validTags }}
          </BaseFormInlineMessage>

          <BaseFormTextarea v-model="data.message" :id="`${_uid}-message`" rows="10" class="mt-4" />

          <p v-if="failed" class="msg error mt-2 text-xs">
            {{ errors[0] }}
          </p>
        </BaseFormGroup>
      </ValidationProvider>
    </BaseLayoutSpaced>
  </div>
</template>

<script>
export default {
  props: {
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    const { from, message } = this;

    return {
      loading: false,
      data: {
        from,
        message,
        ...this.defaultData,
      },
      validTags: [
        '[contact_request:first_name]',
        '[contact_request:last_name]',
        '[contact_request:full_name]',
        '[contact_request:email]',
      ].toString(),
    };
  },

  watch: {
    data: {
      deep: true,
      handler(data) {
        if (Object.keys(data).some((prop) => !data[prop])) {
          this.$emit('update-props', null);
        } else {
          this.$emit('update-props', data);
        }
      },
    },
  },
};
</script>
